import Backend from 'App/Dataman-Backend';
import { apiGet } from '@/app/api/core/http';
import { COMMENTS_PATHS } from './paths';

// Entity names are singular, except where the backend spells them differently
const CATEGORY_TO_ENTITY = {
  companies: 'company',
};

export const commentService = {
  async createComment(data) {
    return Backend.post({
      url: COMMENTS_PATHS.comments,
      data,
    });
  },
  async getComments(queryParams = {}) {
    const params = {
      page: 1,
      itemsPerPage: 100,
      ...queryParams,
    };

    const { data } = await apiGet(COMMENTS_PATHS.comments, { params });

    return [...data].reverse().map(({ comment, createdAt, created }) => ({
      text: comment,
      date: new Date(createdAt).toDateString(),
      user: created,
    }));
  },
  getEntityByCategory(category) {
    return CATEGORY_TO_ENTITY[category] || category.slice(0, category.length - 1);
  },
};
